import type { BuyerActionRequest, BuyerActionResponse } from '../types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  zodBuyerActionRequestSchema,
  zodBuyerActionResponseSchema,
} from './validations';

/**
 * Submits a buyer action response for a call-off.
 * Available actions depend on the call-off's current status.
 *
 * @param callOffId - The call-off ID.
 * @param payload - The buyer action request payload.
 * @returns The updated call-off and available actions.
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Off-Magic-Link/operation/buyer_respond_calloffs__calloff_id__magic_link_respond_post
 */
export const buyerRespond = async (
  callOffId: UUID,
  payload: BuyerActionRequest,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.CALL_OFF.BUYER_RESPOND(callOffId), {
      json: payload,
      validate: {
        body: zodBuyerActionRequestSchema,
      },
    })
    .json<BuyerActionResponse>();

  const validatedResponse = zodBuyerActionResponseSchema.safeParse(response);

  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'Buyer Respond API response has validation errors',
      error: {
        errors: validatedResponse?.error?.issues,
        errorMessage: validatedResponse?.error?.message,
        response,
      },
    });
  }

  return response;
};
